<template>
  <div class="header-table-outer grid-wrap">
    <h2
      v-if="header"
      class="grid--sm-100 grid--lg-50 ucase grey"
      v-html="header"></h2>
    <div
      v-if="content"
      :class="{'header-table-list--three-col': extraColumn}"
      class="header-table-list grid--sm-100 grid--lg-50 bold">
      <div>
        <p
          v-if="tableHeader"
          class="header-table__header">
          {{ tableHeader }}
        </p>
        <div
          v-for="(item, tablekey) in content"
          :key="tablekey"
          class="header-table__item">
          <p v-if="item.label">
            {{ item.label }}
          </p>
          <p v-else-if="item.table_item_left">
            {{ item.table_item_left }}
          </p>
          <p v-if="item.value">
            {{ item.value }}
          </p>
          <p v-else-if="item.table_item_right">
            {{ item.table_item_right }}
          </p>
          <p v-if="extraColumn && item.table_item_3">
            {{ item.table_item_3 }}
          </p>
        </div>
        <p
          v-if="tableFooter"
          class="header-table__footer">
          {{ tableFooter }}
        </p>
      </div>
      <ImageBlock
        v-if="image"
        :content="image" />
      <ImageBlock
        v-if="floorplan"
        :content="floorplan" />
    </div>
  </div>
</template>

<script>
import ImageBlock from '@/components/sections/types/ImageBlock'

export default {
  name: 'HeaderTable',
  components: {
    ImageBlock
  },
  props: {
    header: {
      type: String,
      default: null
    },
    content: {
      type: Array,
      default: null
    },
    tableHeader: {
      type: String,
      default: null
    },
    tableFooter: {
      type: String,
      default: null
    },
    extraColumn: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default: null
    },
    floorplan: {
      type: Object,
      default: null
    }
  },
}
</script>

<style lang="scss" scoped>
.header-table-outer {
  padding: $padding--base 0;

  @include mobile {
    padding: $padding--base-mbl 0;
  }

  .header-table-list {
    .header-table__header {
      margin-bottom: $gutter--base;
    }

    .header-table__item {
      display: flex;
      flex-wrap: wrap;
      column-gap: 0.5rem;
      border-bottom: 1px solid $color--white;
      padding-bottom: rem(5);
      margin-bottom: rem(5);

      p {
        width: calc(50% - (0.5rem/2));
      }

      p:only-child {
        width: 100%;
      }
    }

    &--three-col {
      .header-table__item {
        p {
          width: calc(33.33331% - (0.5rem/1.5));
        }
      }
    }

    .header-table__footer {
      margin-top: $gutter--base;
    }

    .header-table__image {
      margin-top: $gutter--base;
    }
  }
}
</style>
